import { IButtonStyles, IStackStyles } from "@fluentui/react";

import { Theme } from "../../theme/Theme";

interface SearchDropdownStyles {
    itemStyles: IStackStyles;
    listWrapperStyles: IStackStyles;
    actionButtonStyles: IButtonStyles;
    closedListStyles: IStackStyles;
}

export const useSearchDropdownStyles = (itemsCount: number, maxItemsOverlay?: number): SearchDropdownStyles => {
    const rowHeight = 41;

    const count = itemsCount === 0 ? 1 : itemsCount;

    const listWrapperStyles: IStackStyles = {
        root: {
            background: Theme.palette.white,
            fontFamily: Theme.fonts.medium.fontFamily,
            fontSize: 14,
            position: "absolute",
            width: "100%",
            zIndex: 2,
            boxShadow: Theme.effects.elevation8,
            borderRadius: 3,
            overflowY: "auto",
            marginTop: 2,
            height: maxItemsOverlay && count > maxItemsOverlay ? maxItemsOverlay * rowHeight : count * rowHeight
        }
    };

    const closedListStyles: IStackStyles = {
        root: {
            display: "none"
        }
    };

    const itemStyles: IStackStyles = {
        root: {
            cursor: "pointer",
            justifyContent: "center",
            padding: 7,
            height: rowHeight,
            selectors: {
                ":hover": {
                    backgroundColor: Theme.palette.neutralLighter
                }
            }
        }
    };

    const actionButtonStyles: IButtonStyles = {
        root: {
            height: 30,
            maxHeight: 30
        },
        icon: {
            fontSize: 12
        }
    };

    return { itemStyles, listWrapperStyles, actionButtonStyles, closedListStyles };
};
